import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useJoinMotion } from "./JoinMotion";

const VARIANT_STYLES = {
  display: {
    titleSize: { xs: 28, md: 40 },
    mb: { xs: 3, md: 4 },
    titleMb: 1,
    descSize: { xs: 16, md: 17 },
    maxWidth: 720,
  },
  standard: {
    titleSize: { xs: 24, md: 32 },
    mb: { xs: 2.5, md: 3.5 },
    titleMb: 1,
    descSize: { xs: 15, md: 16 },
    maxWidth: 680,
  },
  compact: {
    titleSize: { xs: 20, md: 24 },
    mb: { xs: 2, md: 2.5 },
    titleMb: 0.75,
    descSize: { xs: 14, md: 15 },
    maxWidth: 560,
  },
};

export default function SectionHeader({
  id,
  eyebrow,
  title,
  description,
  align = "center",
  variant = "standard",
  maxWidth,
  descriptionSx,
  eyebrowSx,
}) {
  const { fadeUp } = useJoinMotion();
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.standard;
  const resolvedMaxWidth = maxWidth ?? styles.maxWidth;

  return (
    <Box
      id={id}
      component={motion.div}
      {...fadeUp}
      sx={{
        textAlign: align,
        mb: styles.mb,
        maxWidth: align === "center" ? resolvedMaxWidth : "100%",
        mx: align === "center" ? "auto" : 0,
        scrollMarginTop: { xs: 88, md: 96 },
      }}
    >
      {eyebrow && (
        <Typography
          component="p"
          variant="overline"
          sx={{
            color: "var(--primary-color)",
            fontWeight: 700,
            letterSpacing: 1.5,
            display: "block",
            mb: 0.75,
            fontSize: 11,
            lineHeight: 1.45,
            ...eyebrowSx,
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        component="h2"
        variant="h3"
        sx={{
          fontWeight: 800,
          color: "var(--black-color)",
          fontSize: styles.titleSize,
          letterSpacing: "-0.02em",
          mb: description ? styles.titleMb : 0,
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          component="p"
          sx={{
            color: "var(--dna-color-palette-black-400)",
            fontSize: styles.descSize,
            lineHeight: 1.65,
            maxWidth: align === "center" ? resolvedMaxWidth : "100%",
            mx: align === "center" ? "auto" : 0,
            ...descriptionSx,
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
}
